import { Button, Drawer, Input } from '@dnb/eufemia';
import filter from '@dnb/eufemia/icons/dnb/filter';
import { TrackRoute } from '@portals/shared-frontend/components';
import { debounce } from '@portals/shared-frontend/utils';
import { useMemo, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

import HeroPage from '@/components/HeroPage';
import { HeroContent } from '@/components/HeroPage/HeroContent';
import { HeroContentMenu } from '@/components/HeroPage/HeroContentMenu';
import HeroMenu from '@/components/HeroPage/HeroMenu';
import { EventFilter } from '@/pages/explorer/events/EventFilter';
import { EventFilterTags } from '@/pages/explorer/events/EventFilterTags';
import { PaginatedEvents } from '@/pages/explorer/events/PaginatedEvents';

export default function EventExplorerPage() {
  const query = useRef<string>('');
  const [, setSearchParams] = useSearchParams();

  const debounced = useMemo(
    () =>
      debounce((query: string | undefined) => {
        setSearchParams((prev) => {
          if (query) {
            prev.set('query', query);
          } else {
            prev.delete('query');
          }
          prev.set('page', '0'); // Reset page index on query change
          return prev;
        });
      }, 300),
    [setSearchParams],
  );

  const searchField = (
    <Input
      clear
      icon="loupe"
      on_change={({ value }) => {
        query.current = value;
        debounced(value);
      }}
      placeholder="Search"
      stretch
      value={query.current}
    />
  );

  const filterComponents = <EventFilter />;

  return (
    <div className="dark-mode">
      <HeroPage banner="explorer" title="Events Explorer">
        <TrackRoute name="Events Explorer" path="/explorer/events" type="events" />
        <HeroMenu>
          <div className="flex flex-col gap-2">
            {searchField}
            <Button
              className="self-start"
              onClick={() => {
                query.current = '';
                setSearchParams(undefined);
              }}
              variant="tertiary"
            >
              Clear Filters
            </Button>
            {filterComponents}
          </div>
        </HeroMenu>
        <HeroContent>
          <HeroContentMenu>
            {searchField}
            <Drawer
              id="tagFilterDrawer"
              title="Filters"
              top="small"
              triggerAttributes={{ icon: filter, text: 'Filters', variant: 'tertiary' }}
            >
              {filterComponents}
            </Drawer>
            <EventFilterTags />
          </HeroContentMenu>
          <PaginatedEvents />
        </HeroContent>
      </HeroPage>
    </div>
  );
}
